import { KlarnaPaymentMessageUI } from "./KlarnaPaymentMessageUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "@/hooks/useVariant/useVariant";
import { ensureIsActive } from "@/utils/product/ensureIsActive";
import { CreditIllustration } from "@/types/cobeTypes";
import { recordImpressionByParam } from "@JohnLewisPartnership/experiments-utils";

export function KlarnaPaymentMessage({
  product,
  creditOffersV2,
  runtimeConfig,
  flags,
  experiencesRawObject,
}: Pick<
  StandardProps,
  | "product"
  | "creditOffersV2"
  | "runtimeConfig"
  | "flags"
  | "experiencesRawObject"
>) {
  const { isSelected, variant } = useVariant(product);

  const showKlarnaMessage = !!flags.showKlarnaMessage.value;
  const alwaysShowKlarna = !!flags.alwaysShowKlarna.value;

  const activeProduct = ensureIsActive(product);

  if (!activeProduct || (!alwaysShowKlarna && !isSelected)) {
    return null;
  }

  const someVariantsEligibleForKlarna =
    alwaysShowKlarna &&
    creditOffersV2?.some(({ creditIllustrations }) => {
      return creditIllustrations.some(
        (illustration: CreditIllustration) =>
          illustration.creditProvider.toLowerCase() === "klarna",
      );
    });

  const selectedVariantEligibleForKlarna = creditOffersV2?.find(
    ({ skuId, creditIllustrations }) => {
      if (skuId === variant.aliases.skuId) {
        return creditIllustrations.find(
          (illustration: CreditIllustration) =>
            illustration.creditProvider.toLowerCase() === "klarna",
        );
      }
      return false;
    },
  );

  if (
    selectedVariantEligibleForKlarna ||
    (!isSelected && someVariantsEligibleForKlarna)
  ) {
    recordImpressionByParam(
      runtimeConfig?.monetateEnvironment,
      experiencesRawObject as [],
      "pdp-scaffold-showKlarnaMessage",
      showKlarnaMessage.toString(),
    );
  } else {
    return null;
  }

  return (
    showKlarnaMessage && (
      <KlarnaPaymentMessageUI
        runtimeConfig={runtimeConfig}
        currentPrice={variant.price?.value}
        isSelected={isSelected}
      />
    )
  );
}
